import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Eye, RefreshCw } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const LiveViewersWidget = () => {
  const [status, setStatus] = useState<"loading" | "live" | "offline" | "error">("loading");
  const [activeStreams, setActiveStreams] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchViewers = async () => {
    setLoading(true);
    try {
      const { data, error: fnError } = await supabase.functions.invoke("live-viewers");
      if (fnError) throw fnError;
      if (data?.error === "keys_missing") {
        setErrorMsg("Clés Mux non configurées");
        setStatus("error");
      } else if (data?.error === "auth_failed") {
        setErrorMsg("Clés Mux invalides");
        setStatus("error");
      } else if (data?.error) {
        setErrorMsg("Erreur API Mux");
        setStatus("error");
      } else {
        setActiveStreams(data?.active_streams ?? 0);
        setStatus(data?.is_live ? "live" : "offline");
      }
    } catch (e) {
      console.error("Error fetching viewers:", e);
      setErrorMsg("Erreur réseau");
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchViewers();
    const interval = setInterval(fetchViewers, 30000);
    return () => clearInterval(interval);
  }, []);

  const statusText = () => {
    if (loading) return "Chargement...";
    switch (status) {
      case "live": return `${activeStreams} stream${activeStreams > 1 ? "s" : ""} actif${activeStreams > 1 ? "s" : ""}`;
      case "offline": return "Aucun stream actif";
      case "error": return errorMsg;
      default: return "...";
    }
  };

  return (
    <div className="flex items-center justify-between px-3 py-2.5 rounded-lg border bg-muted/50 border-border">
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4 text-primary" />
        <div className="flex flex-col">
          <span className="text-sm font-medium text-foreground">Mux Streams</span>
          <span className="text-xs text-muted-foreground">{statusText()}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {status === "live" && (
          <Badge variant="outline" className="text-[10px] px-1.5 py-0 border-green-500/50 text-green-400">
            LIVE
          </Badge>
        )}
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6"
          onClick={fetchViewers}
          disabled={loading}
        >
          <RefreshCw className={`w-3 h-3 ${loading ? "animate-spin" : ""}`} />
        </Button>
      </div>
    </div>
  );
};

export default LiveViewersWidget;
